import React, { createContext, useState, useContext, useEffect } from "react";
import { KeycloakContext } from "./KeycloakContext";
import { useLocation } from "react-router-dom";

const SidebarContext = createContext();

export const useSidebar = () => useContext(SidebarContext);

export const SidebarProvider = ({ children }) => {
  const { useFeatures } = useContext(KeycloakContext);
  const location = useLocation();
  const [isExpanded, setIsExpanded] = useState(false);
  const [displayToolTipIcon, setDisplayToolTipIcon] = useState(true);
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  const [activeLink, setActiveLink] = useState(null);

  useEffect(() => {
    if (!activeLink) {
      if (location.pathname === "/" && useFeatures) {
        Object.keys(useFeatures).length > 0
          ? setActiveLink(useFeatures[0].name)
          : "Home";
      } else if (location.pathname === "/sku") {
        setActiveLink("SKU Management");
      } else if (location.pathname.startsWith("/investigations")) {
        setActiveLink("Investigations");
      } else if (location.pathname.startsWith("/settings")) {
        setActiveLink("Settings");
      } else if (location.pathname.startsWith("/admin-tools")) {
        setActiveLink("Admin Tools");
      }
    }
  }, [activeLink, useFeatures]);

  useEffect(() => {
    const handleResize = () => {
      setScreenWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <SidebarContext.Provider
      value={{
        activeLink,
        setActiveLink,
        isExpanded,
        setIsExpanded,
        displayToolTipIcon,
        setDisplayToolTipIcon,
        screenWidth,
      }}
    >
      {children}
    </SidebarContext.Provider>
  );
};
